module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "DEDICATION"
  }, [_vm._v("To Members and Friends"), _c('br'), _vm._v(" at the Westminster Presbyterian Church "), _c('br'), _vm._v("  in Grand Rapids, Michigan "), _c('br'), _vm._v("   where many of the ideas in this book "), _c('br'), _vm._v("    were first planted and a few blossomed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f74c8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stewart_Envisioning_the_Congregation_text_CC1.vue
// module id = 60
// module chunks = 0